<template>
    <div>
        <span>
            <b>{{ _.get(activity, "actorUser.name") }}</b> added <b>{{ _.get(activity, "payload.ipAddress") }}</b> to
            white list.
        </span>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "WhiteListAdded",
    computed: {
        _() {
            return _;
        },
    },
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
